(function () {
  /* cache-bust 2026-08-30-pdp-no-pop */
  var root = document.getElementById("vc-pop");
  if (!root) return;

  /* Never bind or auto-open on product pages (snippet also skips product). */
  var tpl = root.getAttribute("data-template") || "";
  if (tpl === "product") return;

  var KEY = "vela_first_order_popup";
  var DAYS = 14;
  var SITE_MS = 12000;
  var started = Date.now();
  var opened = false;
  var queued = false;

  function readStore() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.at) return null;
      if (Date.now() - data.at > DAYS * 86400000) {
        localStorage.removeItem(KEY);
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  }

  function writeStore(state) {
    try {
      localStorage.setItem(KEY, JSON.stringify({ state: state, at: Date.now() }));
    } catch (e) {}
  }

  var card = root.querySelector(".vc-pop__card");
  var form = root.querySelector(".vc-pop__form");
  var success = root.querySelector(".vc-pop__success");
  var err = root.querySelector(".vc-pop__err");
  var email = root.querySelector('input[type="email"]');
  var consent = root.querySelector('input[name="contact[accepts_marketing]"]');

  function closeState() {
    return success && !success.hidden ? "sent" : "closed";
  }

  function hideRoot() {
    root.classList.remove("is-open");
    root.setAttribute("aria-hidden", "true");
    root.setAttribute("hidden", "");
  }

  function close(state) {
    opened = false;
    root.classList.remove("is-open");
    root.setAttribute("aria-hidden", "true");
    writeStore(state || "closed");
    setTimeout(function () {
      root.setAttribute("hidden", "");
    }, 280);
  }

  function open(force) {
    if (opened) return;
    if (!force && readStore()) return;
    opened = true;
    root.removeAttribute("hidden");
    requestAnimationFrame(function () {
      root.classList.add("is-open");
    });
    root.setAttribute("aria-hidden", "false");
    if (email) setTimeout(function () { email.focus(); }, 180);
  }

  function showSuccess() {
    if (form) form.hidden = true;
    if (success) success.hidden = false;
    if (card) card.classList.add("is-sent");
    writeStore("sent");
  }

  function maybeOpen() {
    if (opened || readStore()) return;
    open(false);
  }

  /* Document-level capture so close works even if the node is cloned
     or other handlers stop the event. Attached before any suppress return. */
  document.addEventListener(
    "click",
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest("[data-vc-pop-close]")) return;
      e.preventDefault();
      e.stopPropagation();
      close(closeState());
    },
    true
  );

  root.addEventListener("click", function (e) {
    if (e.target === root) close(closeState());
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (!root.classList.contains("is-open") && !opened) return;
    close(closeState());
  });

  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (err) {
        err.hidden = true;
        err.textContent = "";
      }
      if (!email || !email.value || !email.checkValidity()) {
        if (err) {
          err.hidden = false;
          err.textContent = "Enter an email.";
        }
        if (email) email.focus();
        return;
      }
      if (consent && !consent.checked) {
        if (err) {
          err.hidden = false;
          err.textContent = "Tick the box to send the code.";
        }
        return;
      }

      var btn = form.querySelector(".vc-pop__go");
      if (btn) btn.disabled = true;

      var fd = new FormData(form);
      fetch(form.action || "/contact", {
        method: "POST",
        body: fd,
        credentials: "same-origin",
        headers: { Accept: "text/html" }
      })
        .then(function () {
          try {
            if (window.klaviyo && typeof window.klaviyo.identify === "function") {
              window.klaviyo.identify({
                email: email.value,
                first_order_popup: true
              });
            } else if (window._klOnsite) {
              window._klOnsite.push(["identify", { $email: email.value }]);
            }
          } catch (err2) {}
          showSuccess();
        })
        .catch(function () {
          if (btn) btn.disabled = false;
          if (err) {
            err.hidden = false;
            err.textContent = "Try again in a moment.";
          }
        });
    });
  }

  var hash = (window.location.hash || "").replace("#", "");
  if (hash === "vela-popup") {
    open(true);
  } else if (hash === "vela-popup-success") {
    opened = true;
    root.removeAttribute("hidden");
    root.classList.add("is-open");
    root.setAttribute("aria-hidden", "false");
    showSuccess();
  } else if (readStore()) {
    hideRoot();
    return;
  }

  setTimeout(function () {
    queued = true;
    maybeOpen();
  }, SITE_MS);

  document.addEventListener("mouseout", function (e) {
    if (e.clientY > 8) return;
    queued = true;
    maybeOpen();
  });

  document.addEventListener(
    "scroll",
    function () {
      var doc = document.documentElement;
      var max = (doc.scrollHeight || 0) - window.innerHeight;
      if (max <= 0) return;
      if (window.scrollY / max < 0.5) return;
      queued = true;
      maybeOpen();
    },
    { passive: true }
  );
})();
